import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HarvestAndPlantingMap from '../harvestAndPlanting/HarvestAndPlantingMap';
import { IN_SEASON } from '../../../constants/mapLayerIds';

const LAYER = IN_SEASON.APPLICATIONS;

export function ApplicationsMap(props) {
  return <HarvestAndPlantingMap {...props} />;
}

ApplicationsMap.propTypes = {
  crop: PropTypes.string.isRequired,
  dates: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  const activeSeason = state.seasons.activeSeasons[props.index];
  const { list } = state.seasons;
  const { liquidData } = list[activeSeason.id];
  const liquidLayer = state.layers.list[activeSeason.id][LAYER];
  const activeSubLayerId = liquidLayer.activeSubLayerIds[props.index];
  const splitIndex = activeSubLayerId.indexOf('_');
  const activeEndDate = parseInt(activeSubLayerId.slice(0, splitIndex), 10);
  const activeCrop = activeSubLayerId.slice(splitIndex + 1);
  const { crop, liquidEndDate, liquidStartDate, liquidYear } = liquidData.find(
    (application) =>
      application.crop === activeCrop &&
      application.liquidEndDate === activeEndDate
  );
  const dates = {
    endDate: liquidEndDate,
    startDate: liquidStartDate,
    year: liquidYear,
  };
  const subLayer = `${dates.endDate}_${crop}`;

  return {
    crop,
    dates,
    // we need to subscribe the map to the intervals to re-fetch tile layers for new legend values
    intervals:
      liquidLayer.subLayers[subLayer] && liquidLayer.subLayers[subLayer].legend,
  };
}

export default connect(mapStateToProps)(ApplicationsMap);
